<script>
const localizationCache = {};

export default {
  methods: {
    getLocalization(name) {
      let currentLanguage = document.documentElement.lang == 'zh' ? 'cn' : document.documentElement.lang;
      if (!localizationCache[currentLanguage]) {
        localizationCache[currentLanguage] = require(`../../../../public/lang/${currentLanguage}.json`);
      }
      const localization = localizationCache[currentLanguage];
      return localization[name] ?? name;
    }
  }
}
</script>
